import 'css-chunksrc/client/pages/landingPage/styles.scss';export default {
  "landingPage": "_landingPage_pwi07_1",
  "header": "_header_pwi07_8",
  "logo": "_logo_pwi07_13",
  "main": "_main_pwi07_18",
  "logIn": "_logIn_pwi07_26",
  "registration": "_registration_pwi07_27",
  "button": "_button_pwi07_40"
};